import { SITE_PAGES } from 'Config';
import SiteDrawerData from 'Data/SiteDrawerData';
import ResourceView from 'Pages/Resources/ResourceView';
import PropTypes from 'prop-types';
import { isUserAuthorized } from 'Util';
import styles from './SiteDrawerContainer.module.css';

const ResourceDrawerButton = ({
  resource,
  resourceId,
  label,
  drawerTitle,
  labelClassName,
  ...props
}) => {
  const buttonLabel = label || resource?.name;
  const theResourceId = resource?.id || resourceId;

  let drawerContent = theResourceId && (
    <ResourceView
      resourceId={theResourceId}
      editable={
        resource && isUserAuthorized(SITE_PAGES.RESOURCE_DETAILS.requiredAuth)
      }
      {...props}
    />
  );

  const onClick = () => {
    SiteDrawerData.open({
      content: drawerContent,
      title: drawerTitle || resource?.name,
    });
  };

  return (
    buttonLabel && (
      <span
        className={labelClassName || styles.drawer_button_text}
        onClick={onClick}>
        {buttonLabel}
      </span>
    )
  );
};

ResourceDrawerButton.propTypes = {
  resource: PropTypes.object,
  resourceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  drawerTitle: PropTypes.string,
  labelClassName: PropTypes.string,
};

export default ResourceDrawerButton;
